module.exports = __webpack_public_path__ + "img/mistake.416c7953.png";